@if (thisProfile$ | async; as data) {
  <ngx-masonry [options]="myOptions" class="masonry-container" id="masonryContainer" #masonryContainer>
    @for (item of data.components.tiles | keyvalue; track item) {
      @if (!item.key.includes('#')) {
        <!-- 'special' tiles have a '#' in their key -->
        <div ngxMasonryItem class="tiles-container masonry-item" [ngClass]="{ 'grid-item--2x2' : item.value.length > 2, 'grid-item--2x1' : item.value.length == 2 }">
          <div class="tiles-container-inner">
            @for (tile of item.value; track tile) {
              <!-- TileType can be - None, Image, Marketing, ModalContent, ModalComponent, MykePage, Page, Photo -->
              <!--
              Old = IsTilePage -> New = ModalContent
              Old = IsPhoto -> New = Photo
              Old - no url and ispage -> New = MykePage
              Old - no url and not ispage -> New = ModalComponent
              New - Image
              New - Marketing
              New - Page
              -->
              @if (tile.Type == 'ModalContent') {
                <div class="grid-item" (click)="openTilePageModal(tile.Label, tile.Name, tile.PageID, data.components.labelLookup, tile.Size)">
                  <ng-container [ngTemplateOutlet]="tileDetails" [ngTemplateOutletContext]="{ tile:tile }"></ng-container>
                </div>
              }
              @if ((tile.Type == 'Marketing') || (tile.Type == 'Photo')) {
                <div class="grid-item grid-item-photo">
                  <ng-container [ngTemplateOutlet]="tileDetails" [ngTemplateOutletContext]="{ tile:tile }"></ng-container>
                </div>
              }
              @if (tile.Type == 'MykePage') {
                <div class="grid-item">
                  <a [routerLink]="['/', tile.Name.toLowerCase() ]">
                    <ng-container [ngTemplateOutlet]="tileDetails" [ngTemplateOutletContext]="{ tile:tile }"></ng-container>
                  </a>
                </div>
              }
              @if (tile.Type == 'ModalComponent') {
                <!-- keyup.enter added for accessibility -->
                <div tabindex="0" class="grid-item" (keyup.enter)="openModal(false, tile.Label, tile.Name, '')" (click)="openModal(false, tile.Label, tile.Name, tile.Size)">
                  <ng-container [ngTemplateOutlet]="tileDetails" [ngTemplateOutletContext]="{ tile:tile }"></ng-container>
                </div>
              }
              @if (tile.Type == 'Page') {
                <div class="grid-item" [class.full-overlay-label]="tile.Name=='MyHrRequests'">
                  <a href="{{tile.Url}}" [target]="((tile.Url.includes('myke.kenan-flagler.unc.edu')) || (tile.Url.includes('myke.business.unc.edu')) ) ? '_self' : '_blank'">
                    <ng-container [ngTemplateOutlet]="tileDetails" [ngTemplateOutletContext]="{ tile:tile }"></ng-container>
                  </a>
                </div>
              }
              @if (tile.Type == 'Image') {
                <div class="grid-item">
                  <ng-container [ngTemplateOutlet]="tileDetails" [ngTemplateOutletContext]="{ tile:tile }"></ng-container>
                </div>
              }
            }
          </div>
        </div>
      }
      @if (item.key.includes('#')) {
        <!-- These tiles have more hardcoded elements which make it easier for us to show special content to the user -->
        @if (item.key.includes('bidding')) {
          <!-- Bidding -->
          <div ngxMasonryItem class="tiles-container tiles-bidding masonry-item">
            <div class="tiles-container-inner">
              <div class="grid-item">
                <!-- we have to draw the tiles and grid item before we call the endpoint, otherwise it is always drawn last -->
                @if (profileService.hasStops) {
                  <div class="tile-stops">
                    <span class="fa-stack fa-lg">
                      <i class="fas fa-octagon fa-lg"></i>
                      <i class="fas fa-exclamation fa-stack-1x"></i>
                    </span>
                  </div>
                }
                @if (bidding.auctionBids$ | async; as auction) {
                  @if (auction.isActive) {
                    @if (getBiddingCountDown$(auction) | async; as countdown) {
                      <a routerLink="/catalog">
                        @if (!auction.hasStarted) {
                          <h2>Bidding</h2>
                        }
                        @if (auction.hasStarted) {
                          <h2 class="tiles-bidding-now">
                            Bid!
                          </h2>
                        }
                        <div class="countdown-box">
                          <div class="countdown-header tiles-bidding-soon tile tile-circle tile-lg" [ngClass]="{'tiles-bidding-soon':!auction.hasStarted, 'tiles-bidding-now': auction.hasStarted}">
                            {{countdown.shortTime}}
                          </div>
                          <div>
                            {{countdown.displayString | titlecase }} {{auction.Timeline | biddingStatus}}
                          </div>
                        </div>
                      </a>
                    }
                  } @else {
                    <a routerLink="/catalog">
                      <h2>Bidding</h2>
                      <div class="tiles-text">You are not currently in any active Bidding rounds.</div>
                    </a>
                  }
                } @else {
                  <a routerLink="/catalog">
                    <h2>Bidding</h2>
                    <div class="tiles-text">You are not currently in any active Bidding rounds.</div>
                  </a>
                }
              </div>
            </div>
          </div>
        }
        @if (item.key.includes('dropadd')) {
          <!-- Registration -->
          @if (enrollments.roundsActive$ | async; as rounds;) {
            <div ngxMasonryItem class="tiles-container tiles-drop-add masonry-item">
              <div class="tiles-container-inner">
                @if (!rounds.hasActiveRound && !rounds.hasUpcoming) {
                  <div class="grid-item">
                    @if (profileService.hasStops) {
                      <div class="tile-stops">
                        <span class="fa-stack fa-lg">
                          <i class="fas fa-octagon fa-lg"></i>
                          <i class="fas fa-exclamation fa-stack-1x"></i>
                        </span>
                      </div>
                    }
                    <!-- no active or upcoming rounds -->
                    <a routerLink="/catalog">
                      <h2>{{item.value[0].Label}}</h2>
                      <div class="tiles-text">You are not currently in any active or upcoming Drop/Add rounds.</div>
                    </a>
                  </div>
                }
                <!-- upcoming -->
                @if (rounds.hasUpcoming && !rounds.hasActiveRound) {
                  <div class="grid-item">
                    @if (profileService.hasStops) {
                      <div class="tile-stops">
                        <span class="fa-stack fa-lg">
                          <i class="fas fa-octagon fa-lg"></i>
                          <i class="fas fa-exclamation fa-stack-1x"></i>
                        </span>
                      </div>
                    }
                    <!-- has upcoming rounds -->
                    <ng-container>
                      <a routerLink="/catalog">
                        <h2 class="tiles-bidding-now">
                          Upcoming!
                        </h2>
                        <div class="countdown-box">
                          <div>
                            Next Drop/Add round will begin {{rounds.upcomingDate | date: 'EEEE, MMMM d, y, \'at\' h:mm a'}}
                          </div>
                        </div>
                      </a>
                    </ng-container>
                  </div>
                }
                @if (rounds.hasActiveRound) {
                  <div class="grid-item tiles-drop-add-active">
                    <!-- create one tile to show all round information  -->
                    @if (profileService.hasStops) {
                      <div class="tile-stops">
                        <span class="fa-stack fa-lg">
                          <i class="fas fa-octagon fa-lg"></i>
                          <i class="fas fa-exclamation fa-stack-1x"></i>
                        </span>
                      </div>
                    }
                    <a routerLink="/catalog">
                      <h2 class="title-drop-add">Register!</h2>
                      <i class="far fa-users-class tiles-icon"></i>
                    </a>
                  </div>
                }
              </div>
            </div>
          }
        }
      }
    }
  </ngx-masonry>
}
<!-- tile details template -->
<ng-template #tileDetails let-tile="tile">
  @if (!!tile.Label && (tile.Type != 'Photo') && (tile.Type != 'Marketing')) {
    <h2>{{tile.Label}}</h2>
  }

  @if ((tile.Type == 'Marketing') || ((tile.Type == 'Photo') && !!tile.Url)) {
    <a href="{{tile.Url}}" aria-label="{{tile.Label}}" title="{{tile.Label}}" target="_blank">
      <div style="background-image: url('{{tile.Image}}');" class="tiles-photo">
        @if (!!tile.Label) {
          <div class="tiles-label" [class.tiles-label-static]="tile.Type == 'Marketing'">
            {{tile.Label}}<i class="far fa-external-link ps-2"></i>
          </div>
        }
      </div>
    </a>
  }

  @if ((tile.Type == 'Photo') && !tile.Url) {
    <div style="background-image: url('{{tile.Image}}');" class="tiles-photo">
      @if (!!tile.Label) {
        <div class="tiles-label">{{tile.Label}}</div>
      }
    </div>
  }

  @if (tile.Type == 'Image') {
    <div style="background-image: url('{{tile.Image}}');" class="tiles-image" [class.tiles-image-with-header]="!!tile.Label"></div>
  }

  @if (tile.Icon != '') {
    <i class="tiles-icon" [class]="tile.Icon"></i>
  }

  @switch (tile.Name) {
    @case ('Kudos') {
      @if (kudos.newKudos$ | async; as newKudos) {
        @if (newKudos.length > 0) {
          <div class="tile-alerts">{{newKudos.length}}</div>
        }
      }
    }
    @case ('Announcements') {
      @if (announcements.summary$ | async; as announcements) {
        @if (announcements.unread > 0) {
          <div class="tile-alerts">{{announcements.unread}}</div>
        }
      }
    }
    @case ('MyHrRequests') {
      <div class="tile-alerts tile-alerts-dark-blue">
        <i class="fas fa-lock"></i><span class="sr-only">VPN or campus network connection required.</span>
      </div>
      <div class="tiles-label tiles-label-h-100">
        <p>MyKE Admin<i class="far fa-external-link ps-2"></i></p>
        <span class="small">VPN or campus network connection required</span>
      </div>
    }
  }

</ng-template>
